import { ConfirmationDialog } from './ConfirmationDialog';

interface ProjectReplacementDialogProps {
  readonly confirmLabel: string;
  readonly description: string;
  readonly onCancel: () => void;
  readonly onConfirm: () => void;
  readonly returnFocusTo?: HTMLElement | null | undefined;
  readonly title: string;
}

export function ProjectReplacementDialog({
  confirmLabel,
  description,
  onCancel,
  onConfirm,
  returnFocusTo,
  title,
}: ProjectReplacementDialogProps) {
  return (
    <ConfirmationDialog
      confirmLabel={confirmLabel}
      description={description}
      onCancel={onCancel}
      onConfirm={onConfirm}
      returnFocusTo={returnFocusTo}
      title={title}
    />
  );
}
